import { useCallback } from "react";
import { ShipmentRow, TableActionDropdownItem } from "@src/shipments/types";

// Returns a callback that runs a chosen action against the palette's row. The
// palette is closed first (its own state) so the action can open its own modal
// via setModalOpen without being clobbered. The row is already selected (set on
// right-click), so it is not re-selected here.
export function useRunPaletteAction(
  row: ShipmentRow | undefined,
  close: () => void
) {
  return useCallback(
    (item: TableActionDropdownItem) => {
      if (!row) return;
      close();
      item.onClick(row);
    },
    [row, close]
  );
}
